///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export function triggerLiveTabContentPersistenceEpic(): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          live: {
            form: {
              input: { getFormTabContentToPersist },
            },
          },
        },
      },
      scheduler,
    },
  ) => {
    const newForm$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === 'live'),
      map(({ id }) => id),
    );
    const modifyForm$ = actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_FORM_FIELD_CHANGED'),
      debounceTime(3_000, scheduler),
      map(({ tabId }) => tabId),
    );
    return merge(modifyForm$, newForm$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const persistedTabContent = getFormTabContentToPersist(state, tabId);
        if (persistedTabContent === undefined) {
          return EMPTY;
        }
        const workspaceType = getWorkspaceType(state, tabId) as SecondaryWorkspaceType;
        return of(liveInputFormActions.tabContentPersistenceRequested(tabId, workspaceType, persistedTabContent));
      }),
    );
  };
}
